import { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { Card, CardHead, Btn, TableWrap, Th, Td, Pill, EmptyState } from "../kit";
import { fmtINR, activeClientsDue, renewalsWhatsApp, formatDMY } from "../../lib/finance";
import { toast } from "sonner";
import { Copy } from "lucide-react";

export default function ActiveClients() {
  const { clients } = useData();
  const rows = useMemo(() => activeClientsDue(clients, 6), [clients]);

  const copy = () => {
    navigator.clipboard.writeText(renewalsWhatsApp(rows))
      .then(() => toast.success("Copied — paste straight into WhatsApp"))
      .catch(() => toast.error("Could not copy"));
  };

  const tone = (d) => (d <= 30 ? "expense" : d <= 90 ? "brand" : "income");
  const label = (d) => {
    if (d <= 0) return "ending today";
    const m = Math.floor(d / 30), dd = d % 30;
    return m <= 0 ? `${d}d left` : `${m} mo ${dd}d left`;
  };

  return (
    <Card>
      <CardHead
        title="Active Clients"
        subtitle={`${rows.length} ${rows.length === 1 ? "client" : "clients"} on a plan ending within the next 6 months`}
        right={<Btn variant="outline" onClick={copy} data-testid="active-clients-whatsapp-copy-button"><Copy className="h-4 w-4" /> WhatsApp summary</Btn>}
      />
      <div className="mt-4">
        {rows.length === 0 ? (
          <EmptyState>No active plans ending in the next 6 months.</EmptyState>
        ) : (
          <TableWrap>
            <thead>
              <tr>
                <Th>Name</Th><Th>Plan ends</Th><Th>Time left</Th>
                <Th className="text-right">Balance</Th><Th className="text-right">Total Paid</Th>
              </tr>
            </thead>
            <tbody data-testid="active-clients-table">
              {rows.map((c) => (
                <tr key={c.id} className="hover:bg-slate-50">
                  <Td className="font-semibold text-slate-900">{c.name}</Td>
                  <Td className="text-slate-600">{formatDMY(c.endDate)}</Td>
                  <Td><Pill tone={tone(c.daysLeft)}>{label(c.daysLeft)}</Pill></Td>
                  <Td className="text-right tnum">{c.balance > 0 ? <Pill tone="expense">{fmtINR(c.balance)}</Pill> : <Pill tone="income">Cleared</Pill>}</Td>
                  <Td className="text-right tnum text-emerald-600 font-semibold">{fmtINR(c.paid)}</Td>
                </tr>
              ))}
            </tbody>
          </TableWrap>
        )}
      </div>
      <div className="h-4" />
    </Card>
  );
}
